// extracted by mini-css-extract-plugin
export var columnList = "_en-0";